// /index.html -> /
// /index.html#page -> /index.html/page
// /index.html#/page -> /index.html/page
// /index.html#sub/page -> /index.html/sub/page
// /index.html#/sub/page -> /index.html/sub/page
// /index.html#page?param=1 -> /index.html/page?param=1
// /index.html#/page?param=1 -> /index.html/page?param=1
// /index.html#page?param=1&query=2 -> /index.html/page?param=1&query=2
// /index.html#/page?param=1&query=2 -> /index.html/page?param=1&query=2
// /index.html?param=1&query=2 -> /index.html?param=1&query=2
// /index.html?param=1&query=2.3.4 -> /index.html?param=1&query=2.3.4
// /index.html?param=1&query=2#page -> /index.html/page?param=1&query=2
// /index.html?param=1&query=2#page -> /index.html/page?param=1&query=2
const fromHashToBrowser = (path: string, base?: string): string => {
    const INDEX = base ?? 'index.html';

    let page = '';
    let query = '';

    if (path?.replace(/[//#]/g, '') === INDEX) {
        return '/';
    }

    const pageExpr = /#\/*[\w/-]+\?*/;
    const pages = path.match(pageExpr);
    if (pages?.length) {
        page = pages[0].replace(/#\/|#|\?|\/\?*$/g, '');
    }

    const queryExpr = /\?[^?#]+#*/;
    const queries = path.match(queryExpr);
    if (queries?.length) {
        query = queries[0].replace(/#/, '');
    }
    return `/${INDEX}${page.length ? '/' : ''}${page}${query}`;
};

export { fromHashToBrowser };
